import React from "react";
import { Add } from "@mui/icons-material";
import AddEditZoneSlider from "./addEditZoneSlider/AddEditZoneSlider";
import { CircularProgress, Table } from "@component";
import { tableCellData } from "./zone.const";
import zoneController from "./zone.controller";
import {
  StyledBox,
  StyledButton,
  StyledContainer,
  StyledProgressContainer,
  StyledSearchInput,
  StyledText,
} from "./zone.style";

const Zone: React.FC = () => {
  const {
    openDrawer,
    handleOpen,
    handleClose,
    index,
    loading,
    zone,
    editZoneStatus,
    filter,
    filterData,
    searchValue,
  } = zoneController();
  return (
    <StyledContainer>
      <StyledBox>
        <StyledText variant="h4">Zones</StyledText>
        <StyledSearchInput
          placeholder="Type something..."
          value={searchValue}
          onChange={(val) => filter(val?.target.value)}
        />
        <StyledButton
          onClick={() => handleOpen()}
          startIcon={<Add fontSize="large" />}
        >
          Add Zone
        </StyledButton>
        <AddEditZoneSlider
          openDrawer={openDrawer}
          handleCloseIcon={handleClose}
          zoneId={index}
        />
      </StyledBox>
      {loading ? (
        <StyledProgressContainer>
          <CircularProgress size={40} color={"primary"} />
        </StyledProgressContainer>
      ) : (
        <Table
          tableData={filterData === null ? zone : filterData}
          tableCellData={tableCellData}
          isEditButton
          handleEdit={(id) => handleOpen(id)}
          handleSwitch={(id, check) => editZoneStatus(id, check)}
        />
      )}
    </StyledContainer>
  );
};

export default Zone;
